import React, { Component } from "react";

import "./Pagination.css";

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.on_page_change = this.on_page_change.bind(this);
    }

    componentDidMount() {
        let { total, count, page } = this.props;
        this.setState({ total, count, page });
    }

    componentDidUpdate() {
        let { total, count, page } = this.props;

        if (
            total != this.state.total ||
            count != this.state.count ||
            page != this.state.page
        ) {
            this.setState({ total, count, page });
        }
    }

    on_page_change(page) {
        this.setState({ page });
        this.props.on_page_change(page);
    }

    state = { total: null, count: null, page: null };
    render() {
        let { total, count, page } = this.state;
        let pagination = [];

        let pages = parseInt(total / count) + (total % count > 0 ? 1 : 0);
        if (pages == 1) return;
        for (let i = 0; i < pages; i++) {
            if (pages > 7) {
                if (
                    i !== 0 &&
                    i !== page - 2 &&
                    i !== page - 1 &&
                    i !== page &&
                    i !== page + 1 &&
                    i !== page + 2 &&
                    i !== pages - 1
                ) {
                    if (pagination[pagination.length - 1] != null) {
                        pagination.push(null);
                    }
                    continue;
                }
            }

            pagination.push(
                <button
                    key={i}
                    className={"page btn " + (page === i ? "confirm" : "info")}
                    onClick={(ev) => {
                        this.on_page_change(i);
                    }}
                >
                    {i + 1}
                </button>
            );
        }

        if (pages > 7) {
            pagination = pagination.map((p, i) => {
                if (p === null) return <div key={i * 10}>...</div>;
                return p;
            });
        }

        return (
            <div className="PaginationComponent">
                {pages > 1 && page > 0 && (
                    <button
                        key={"prev"}
                        className="btn danger"
                        onClick={(ev) => {
                            this.on_page_change(page - 1);
                        }}
                    >
                        {"<"}
                    </button>
                )}

                {pagination}

                {page !== pages - 1 && (
                    <button
                        key={"next"}
                        className="btn danger"
                        onClick={(ev) => {
                            this.on_page_change(page + 1);
                        }}
                    >
                        {">"}
                    </button>
                )}
            </div>
        );
    }
}

export default Pagination;
